<div class="container">
	<div class="row justify-content-center">
		<div class="col-12 col-lg-4 text-center big-logo-page">
            <div class="logo d-flex justify-content-center">
                <img src="assets/images/logo-light.svg" alt="logo-atalaya-light">
            </div>

            <h1 class="text-center">404</h1>
            <p>{{ 'NOT_FOUND.text' | translate }}</p>
		</div>
    </div>
</div>
